<template>
  <div>
    <modal id="add-billing">
      <template slot="header"> Start with the {{ plan.name }} plan </template>
      <alert v-if="loading" type="loader" color="secondary"
        >Loading Payment Options....</alert
      >
      <div v-if="!loading && cards.length > 0" class="form-group">
        <label>Select Existing Card</label>
        <table class="table">
          <tr v-for="card in cards" :key="card.id">
            <td>
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  name="card"
                  v-model="paymentCard"
                  :value="card"
                  class="custom-control-input"
                  id="customCheck1"
                />
                <label class="custom-control-label" for="customCheck1"
                  >...{{ card.last4 }}</label
                >
              </div>
            </td>
            <td>{{ card.exp_month }} / {{ card.exp_year }}</td>
            <td>
              <badge>
                {{ card.brand }}
              </badge>
            </td>
          </tr>
        </table>
      </div>
      <div class="form-group">
        <label>Add New Card</label>
        <span id="cc-block"></span>
      </div>
      <template slot="footer">
        <button @click="doAddCard" class="btn btn-sm btn-success">
          <icon type="save" /> Save New Card
        </button>
        <button
          type="button"
          :disabled="paymentCard == null"
          @click="doSubscription"
          class="btn btn-sm btn-primary"
        >
          <span v-if="!saving"><icon type="credit-card" /> Subscribe Now</span>
          <span
            class="spinner-border spinner-border-sm"
            v-if="saving"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-secondary"
          data-dismiss="modal"
        >
          Close
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "AddBilling",
  props: {
    vendor: {
      type: Object,
      required: true,
    },
    plan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stripe: null,
      card: null,
      loading: false,
      cards: [],
      paymentCard: null,
    };
  },
  computed: {
    ...mapState(["saving"]),
  },
  mounted() {
    this.stripe = window.Stripe(process.env.VUE_APP_STRIPE);
    let elements = this.stripe.elements();

    let style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };

    this.card = elements.create("card", {
      style: style,
      classes: { base: "form-control" },
      hidePostalCode: true,
    });
    this.card.mount("#cc-block");
    this.getCards();
  },
  methods: {
    getCards: function () {
      this.loading = true;
      this.$http
        .get(`vendors/${this.vendor.id}/billing/cards`)
        .then((result) => {
          this.loading = false;
          this.cards = result.data.data;
        });
    },
    doSubscription: function () {
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      let customerKey = this.vendor.billingKey;
      let cardId = this.paymentCard.id;
      let planId =
        process.env.NODE_ENV != "development"
          ? this.plan.stripe.live.plan
          : this.plan.stripe.dev.plan;

      this.$http
        .post(`vendors/billing/subscribe`, {
          vendor: this.vendor.id,
          customer: customerKey,
          plan: planId,
          card: cardId,
        })
        .then(() => {
          this.$store.commit("SET_SAVING_STATE", false, { root: true });
          this.$store.dispatch("hideModal", null, { root: true });
        });
    },
    doAddCard: function () {
      let http = this.$http;
      let vendor = this.vendor;
      let store = this.$store;
      let cards = this.cards;
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.stripe.createToken(this.card).then(function (result) {
        if (result.error) {
          alert(result.error.message);
          store.commit("SET_SAVING_STATE", false, { root: true });
        } else {
          http
            .post(`vendors/${vendor.id}/billing/add-card`, {
              token: result.token.id,
            })
            .then((result) => {
              store.commit("SET_SAVING_STATE", false, { root: true });
              cards.push(result.data.data);
            });
        }
      });
    },
  },
};
</script>
<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
